import React from 'react';
import defaultLocales from 'globals/locales/default';
import FsTooltip from 'ui-elements/tooltips/FsTooltip';
import FsQuestionMarkContainedIcon from 'ui-elements/icons/FsQuestionMarkContained';
import FsEnterpriseForm from 'ui-elements/forms/FsEnterpriseForm';
import {
  Headline,
  HeadlineWrapper,
} from './EnterpriseFormContainer.style-elements';

interface BillingInfoProps {
  onChange: (isValid: boolean) => void;
}

const EnterpriseFormContainer: React.FC<BillingInfoProps> = ({ onChange }) => {
  return (
    <>
      <HeadlineWrapper>
        <Headline>{defaultLocales.message}</Headline>
        <FsTooltip title={defaultLocales.enterpriseMessageTooltipInfo}>
          <FsQuestionMarkContainedIcon />
        </FsTooltip>
      </HeadlineWrapper>
      <FsEnterpriseForm onChange={onChange} />
    </>
  );
};

export default EnterpriseFormContainer;
